export const shouldShowMobileDesign = ({ isModal }) => isModal;
